export default {
    paymentGeneratedLink: null
}
